import {
  REWARD_POOL_TICKET_CURRENCY,
  RewardPoolTicketCurrencyType,
} from '@shared/api/types/rewardPools';
import { concatCurrencyToAmount } from '@shared/helpers/formatters/concatCurrencyToAmount';

import { PriceDetailItemType, PriceDetails } from '@ui/uikit/components/common/PriceDetails';
import { formatReward } from '@ui/uikit/utils';

type Props = {
  currencyType: RewardPoolTicketCurrencyType;
  ticketsAmount: number;
};

export const TicketPriceDetails = ({ currencyType, ticketsAmount }: Props) => {
  const { price, currency } = currencyType;

  const items: PriceDetailItemType[] =
    currency === REWARD_POOL_TICKET_CURRENCY.FREE
      ? [{ description: 'You will use', value: `${ticketsAmount * price} Raffle Credit` }]
      : [
          {
            description: 'Ticket price',
            value: `${concatCurrencyToAmount(formatReward(price), currency, {
              stableToDollar: false,
            })}`,
          },
          {
            description: 'Total',
            value: concatCurrencyToAmount(formatReward(ticketsAmount * price), currency, {
              stableToDollar: false,
            }),
          },
        ];

  return <PriceDetails items={items} />;
};
